import React, { FC, useEffect, useState } from 'react';
import cls from './Arrow.module.css';
import { useMousePosition } from '../../../hooks/useMousePosition';
import { useSelector } from 'react-redux';

export const Arrow = ({ position, scrollLeft }) => {
    const { isConnection, first } = useSelector((state) => state.connectionReducer);
    const { mousePosition, scrollPosition } = useMousePosition();
    const [left, setLeft] = useState(0);
    const [initLeft, setInitLeft] = useState(scrollLeft);
    const [ssss, setSsss] = useState(scrollPosition);
    const [setX2, setSetX2] = useState(0);
    const [setY2, setSetY2] = useState(0);

    const distanceFromGant = $('#gant').offset();

    useEffect(() => {
        setInitLeft(scrollLeft);
        setSsss(scrollPosition);
    }, []);

    useEffect(() => {
        if (!isConnection) {
            // setSsss(scrollPosition);
            // setInitLeft(scrollLeft);
        } else {
            if (isConnection) setLeft(initLeft - scrollLeft);
        }
    }, [isConnection, scrollLeft]);

    if (!isConnection) return null;

    return (
        <>
            <svg
                className={cls.connectorLine}
                style={{
                    left: first.x - position.x + scrollLeft - distanceFromGant.left,
                    top: first.y - position.y - distanceFromGant.top,
                    height: 10,
                }}
            >
                <line
                    x1={left}
                    y1={ssss}
                    x2={mousePosition.x ? mousePosition.x - first.x : 0}
                    y2={
                        mousePosition.y
                            ? mousePosition.y - first.y + scrollPosition
                            : scrollPosition
                    }
                    stroke="#1094F7"
                    strokeDasharray="5"
                    strokeWidth="1"
                ></line>
            </svg>
        </>
    );
};
